import { cn } from "@/lib/utils";
import { Card } from "./Card";

interface StatCardProps {
  title: string;
  value: string | number;
  change?: string;
  changeType?: "up" | "down" | "neutral";
  icon?: React.ReactNode;
  className?: string;
}

export function StatCard({ title, value, change, changeType = "neutral", icon, className }: StatCardProps) {
  return (
    <Card className={cn("p-6", className)}>
      <div className="flex items-start justify-between">
        <div>
          <p className="text-sm text-text-muted">{title}</p>
          <p className="mt-1 text-2xl font-semibold text-white">{value}</p>
          {change && (
            <p
              className={cn("mt-1 text-xs", {
                "text-success": changeType === "up",
                "text-danger": changeType === "down",
                "text-text-dim": changeType === "neutral",
              })}
            >
              {change}
            </p>
          )}
        </div>
        {icon && <div className="text-text-dim">{icon}</div>}
      </div>
    </Card>
  );
}
